export default __webpack_public_path__ + "static/media/KostyaMMobile.097162df.png";